import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { categoryColorMap } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            浏览剧集分类
          </h2>
          <p className="text-sm text-foreground-600 mt-2">
            按主题探索不同维度的伦理剧世界
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => {
            const colors = categoryColorMap[cat.color] || { bg: 'bg-primary-100', text: 'text-primary-700' };
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group flex flex-col items-center text-center p-4 md:p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300/50 transition-all cursor-pointer"
              >
                <span className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full ${colors.bg} ${colors.text} mb-3 group-hover:scale-110 transition-transform`}>
                  <i className={`${cat.icon} text-lg md:text-xl`}></i>
                </span>
                <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">
                  {cat.name}
                </span>
                <span className="text-xs text-foreground-500 mt-1 line-clamp-1 hidden sm:block">
                  {cat.description}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}